import appPath from "./appPath";
import Message from "./Message";
import { SCREENS } from "../../../common/constants/Constants";

export function getNextScreenAfterCheckUser(user: User = {}): undefined | string {
    if (appPath.isIframePath()) {
        Message.userSignedIn(user);

        return;
    }

    return appPath(SCREENS.ACCOUNT);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getNextScreenAfterSignIn(
    user: User,
    location: { query: Record<string, string> } = { query: {} }
): undefined | string {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (location.query.redirectTo) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
        return location.query.redirectTo;
    }

    if (!user.industry) {
        Message.userSignedIn(user);

        return appPath.withIframePrefix(SCREENS.PROFESSION);
    }

    if (appPath.isIframePath()) {
        Message.userSignedIn(user);
        Message.closeWindow();

        return;
    }

    return appPath(SCREENS.ACCOUNT);
}

export default {
    getNextScreenAfterCheckUser,
    getNextScreenAfterSignIn
};
